// `extension-browser.service.ng1.ts`'s `getBrowser()`, ported.
//
// ⚠️ IT PICKS WHICH SCREENSHOTS THE ENABLE-COOKIES PAGE SHOWS, and three directories of
// GIFs exist because the three browsers put the cookie setting in three different places:
// `/static/assets/img/extension/enable-cookies/<browser>/{3rd-party,domain-specific}.gif`.
// Hardcoding `chrome`, as the first port did, shows a Chrome walkthrough to an Edge user —
// and it was also the whole remaining diff on that route. The reference was captured in
// Playwright's Chromium, which reports no "Google Chrome" brand and therefore loads the
// `chromium/` GIFs; ours loaded `chrome/`, a different 258KB file, so the two canvases drew
// different pictures at identical geometry. 4.40% that read as a layout defect and was a
// missing user-agent check.
//
// ⚠️ IT IS `userAgentData`, NOT THE UA STRING, and that is upstream's choice rather than a
// modernisation: every Chromium UA string contains "Chrome", so the Chrome/Chromium split
// this makes cannot be read out of it at all.

export type BrowserFamily = 'edge' | 'chrome' | 'chromium'

interface UserAgentBrand {
  brand: string
  version: string
}

/**
 * The brands list, or undefined where the API does not exist.
 *
 * ⚠️ UPSTREAM THROWS HERE AND THE PORT DOES NOT. `getBrowser()` reads
 * `navigator.userAgentData.brands` with no guard, so on Firefox or Safari the whole
 * controller rejects and the page renders empty. Those browsers cannot run this extension,
 * which is presumably why nobody hit it — but "no browser detected" has a correct answer
 * already (`chromium`, the fallback branch), and taking the page down instead is not
 * behaviour worth reproducing.
 */
function brands(): UserAgentBrand[] | undefined {
  const data = (navigator as Navigator & { userAgentData?: { brands?: UserAgentBrand[] } }).userAgentData
  return data?.brands
}

export function browserFamilyFrom(list: readonly UserAgentBrand[] | undefined): BrowserFamily {
  if (list === undefined) return 'chromium'
  if (list.some((entry) => entry.brand.toLowerCase() === 'microsoft edge')) return 'edge'
  if (list.some((entry) => entry.brand.toLowerCase() === 'google chrome')) return 'chrome'
  return 'chromium'
}

export function browserFamily(): BrowserFamily {
  return browserFamilyFrom(brands())
}
